<script setup lang="ts">
import type { INabooContentLearningGrainChildrenDto } from '@/core/domain/nabooContent/NabooContent.types.ts'
import { computed } from 'vue'
import {
  NabooContentLearningGrain,
  NabooContentLearningGrainQuiz,
  NabooContentLearningSupport
} from '@/core/domain/nabooContent/NabooContent.ts'
import { useDialog } from 'primevue/usedialog'
import CNabooContentQuizDialog from '@/presentation/components/content/CNabooContentQuizDialog.vue'
import CBaseCard from '@/presentation/components/base/CBaseCard.vue'

// PROPS
const props = defineProps<{
  grain: NabooContentLearningGrain
  children: INabooContentLearningGrainChildrenDto
}>()

// SERVICES
const dialog = useDialog()

// ACTIONS
const openQuizDialog = async (
  input: NabooContentLearningGrainQuiz,
  grain: NabooContentLearningGrain
) => {
  console.log(input, grain, 'input grain')
  dialog.open(CNabooContentQuizDialog, {
    props: {
      header: `Grain ${grain.order} : ${grain.title}`,
      modal: true,
      dismissableMask: true,
      draggable: false,
      style: 'width: 50vw',
      breakpoints: {
        '960px': '50vw',
        '640px': '95vw'
      }
    },
    data: {
      quiz: input.quiz,
      subtitle: input.title
    }
  })
}

// COMPUTED
const getContent = computed(() => {
  if (props.children instanceof NabooContentLearningSupport) {
    return `${(props.children as NabooContentLearningSupport).url}`
  } else if (props.children instanceof NabooContentLearningGrainQuiz) {
    return `${(props.children as NabooContentLearningGrainQuiz).countQuestions} question(s)`
  } else {
    return ''
  }
})
</script>

<template>
  <c-base-card class="col-span-3">
    <template #header>
      <div class="flex w-full flex-row justify-between">
        <h4 class="text-lg font-medium">{{ children.title }}</h4>
        <span
          v-if="children instanceof NabooContentLearningGrainQuiz"
          class="flex-initial cursor-pointer self-stretch text-blue-500"
          @click="() => openQuizDialog(children as NabooContentLearningGrainQuiz, grain)"
        >
          <i class="pi pi-eye" />
        </span>
        <a
          v-else
          :href="(children as NabooContentLearningSupport).url"
          target="_blank"
          class="flex-initial self-stretch align-top text-blue-500"
        >
          <i class="pi pi-external-link" />
        </a>
      </div>
    </template>
    <template #content>
      <p class="text-surface-900 dark:text-surface-0 text-sm italic" :class="$style.ContentCard">
        {{ getContent }}
      </p>
    </template>
  </c-base-card>
</template>

<style module>
.AspectCard {
  display: flex;
  color: var(--bo-primary);
  max-width: 300px;
  min-width: 200px;

  :global(.p-card-body) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    align-content: start;
    width: 100%;
  }

  :global(.p-card-caption) {
    width: 100%;
  }

  :global(.p-card-content) {
    align-items: start;
    align-content: start;
    align-self: start;
    vertical-align: top;
  }
}

.ContentCard {
  word-break: break-all;
}
</style>
